import { addStyles } from 'ethcss'
import { IStyles, colors } from 'theme'

export const tabStyles: IStyles = {
    tab: {
        appearance: 'none',
        position: 'relative',
        flexShrink: 0,
        padding: '0 0 12px',
        border: 0,
        borderBottom: '2px solid transparent',
        background: 'transparent',
        color: colors.blackLight,
        fontSize: 14,
        lineHeight: '20px',
        cursor: 'pointer',
        transition: 'color 160ms ease, border-color 160ms ease',
        '&:hover': {
            color: colors.blueAccent,
        },
        '&:focus-visible': {
            outline: `2px solid ${colors.blueAccent}`,
            outlineOffset: 3,
            borderRadius: 2,
        },
    },
    selected: {
        color: colors.blueAccent,
        borderBottomColor: colors.blueAccent,
        fontWeight: 500,
    },
    disabled: {
        color: colors.grey,
        cursor: 'default',
        '&:hover': {
            color: colors.grey,
        },
    },
}

addStyles(tabStyles)
